import type { TextDirection } from "./direction.js";

/** 물리 수평 정렬 — Phaser `TextStyle.align`과 동일 어휘. */
export type HAlign = "left" | "center" | "right";

/**
 * 논리 정렬(start/center/end)을 방향에 따라 물리 정렬로 변환한다.
 * - LTR: start=left, end=right
 * - RTL: start=right, end=left (교차)
 * - center는 방향 불변
 *
 * 라벨을 "줄의 시작에 붙인다"는 의도를 `"start"`로 표현하면 LTR/RTL에서 알아서 좌/우로 간다.
 */
export function resolveTextAlign(logical: "start" | "center" | "end", dir: TextDirection): HAlign {
  if (logical === "center") return "center";
  const isStart = logical === "start";
  if (dir === "rtl") return isStart ? "right" : "left";
  return isStart ? "left" : "right";
}

/** 물리 정렬 → Phaser `setOrigin` x 값 (left=0, center=0.5, right=1). */
export function resolveOriginX(align: HAlign): number {
  if (align === "left") return 0;
  if (align === "right") return 1;
  return 0.5;
}
